import { render, staticRenderFns } from "./RxPlayer.vue?vue&type=template&id=e4d5d3cc&scoped=true&"
import script from "./RxPlayer.vue?vue&type=script&lang=js&"
export * from "./RxPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d5d3cc",
  null
  
)

export default component.exports